import snakeCase from 'lodash/snakeCase';
import type { Ref } from 'vue';
import { computed } from 'vue';
import { formatPriceByMarketType } from '@/components/myBets/useBetDisplay';
import { i18n } from '@/core/lib/i18n';
import type { IBet } from '@/interface/IBet';
import { SubBetStatus } from '@/interface/enum';

export function getSubBetStatusResultsDisplay(status: SubBetStatus): string {
    const enumKey = SubBetStatus[status];
    if (!enumKey) {
        return '';
    }
    return i18n.t(`sub_bet_status_${snakeCase(enumKey)}`);
}

function isDisplayParlayFinalPriceScenario(bet: IBet): boolean {
    return bet.isBetBuilder && bet.isSettled && bet.odds !== bet.parlayFinalOdds;
}

export function useBetBuilderBetDisplay(bet: Ref<IBet>) {
    const isDisplayParlayFinalPrice = computed(() => isDisplayParlayFinalPriceScenario(bet.value));
    const parlayFinalPriceDisplay = computed(() => formatPriceByMarketType(bet.value.parlayFinalOdds, bet.value.marketType));

    return {
        isDisplayParlayFinalPrice,
        parlayFinalPriceDisplay,
    };
}
